/**
 * @generated SignedSource<<a7e843ac4243465f57577290082cc2d3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type InstructorDetailScreenQuery$variables = {
  facilitySlug: string;
  instructorId: string;
};
export type InstructorDetailScreenQuery$data = {
  readonly facility: {
    readonly " $fragmentSpreads": FragmentRefs<"InstructorAvailabilityList_facility" | "useFacilityLessonBookingDays_facility">;
  } | null | undefined;
  readonly node: {
    readonly id?: string;
    readonly " $fragmentSpreads": FragmentRefs<"InstructorHeaderFragment_staffProfile">;
  } | null | undefined;
  readonly session: {
    readonly " $fragmentSpreads": FragmentRefs<"InstructorHeaderFragment_session" | "LessonsSignedOutBanner_session">;
  } | null | undefined;
};
export type InstructorDetailScreenQuery = {
  response: InstructorDetailScreenQuery$data;
  variables: InstructorDetailScreenQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "facilitySlug"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "instructorId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "instructorId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = [
  {
    "kind": "Variable",
    "name": "slug",
    "variableName": "facilitySlug"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v5 = [
  (v4/*: any*/),
  (v2/*: any*/)
],
v6 = [
  (v2/*: any*/)
],
v7 = {
  "kind": "InlineFragment",
  "selections": (v6/*: any*/),
  "type": "Node",
  "abstractKey": "__isNode"
},
v8 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "bookingWindowDays",
    "storageKey": null
  },
  (v2/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "patronSelectVenue",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "InstructorDetailScreenQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "InstructorHeaderFragment_staffProfile"
              },
              (v2/*: any*/)
            ],
            "type": "StaffProfile",
            "abstractKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Session",
        "kind": "LinkedField",
        "name": "session",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "InstructorHeaderFragment_session"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "LessonsSignedOutBanner_session"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "Facility",
        "kind": "LinkedField",
        "name": "facility",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "useFacilityLessonBookingDays_facility"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "InstructorAvailabilityList_facility"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "InstructorDetailScreenQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Image",
                "kind": "LinkedField",
                "name": "profileImage",
                "plural": false,
                "selections": [
                  {
                    "alias": "publicId",
                    "args": null,
                    "kind": "ScalarField",
                    "name": "renderingKey",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "StaffUser",
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "fullName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "firstName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "lastName",
                    "storageKey": null
                  },
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Variable",
                    "name": "facilitySlug",
                    "variableName": "facilitySlug"
                  }
                ],
                "concreteType": "InstructorDepartmentProfile",
                "kind": "LinkedField",
                "name": "instructorDepartmentProfile",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "headline",
                    "storageKey": null
                  },
                  (v2/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "type": "StaffProfile",
            "abstractKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Session",
        "kind": "LinkedField",
        "name": "session",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "currentClientProfile",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "member",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "membershipType",
                    "plural": false,
                    "selections": (v5/*: any*/),
                    "storageKey": null
                  },
                  (v7/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": (v6/*: any*/),
                    "type": "Customer",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v6/*: any*/),
                    "type": "Member",
                    "abstractKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Club",
                    "kind": "LinkedField",
                    "name": "club",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "slug",
                        "storageKey": null
                      },
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v7/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": (v5/*: any*/),
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "Facility",
        "kind": "LinkedField",
        "name": "facility",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Club",
            "kind": "LinkedField",
            "name": "club",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "supportsPublic",
                "storageKey": null
              },
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PrivateLessonsPermissionSet",
            "kind": "LinkedField",
            "name": "privateLessonsPermissionSet",
            "plural": false,
            "selections": (v8/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PublicLessonsPermissionSet",
            "kind": "LinkedField",
            "name": "publicLessonsPermissionSet",
            "plural": false,
            "selections": (v8/*: any*/),
            "storageKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "017b93a1c7a28f89cc9ab28fed3071ec",
    "id": null,
    "metadata": {},
    "name": "InstructorDetailScreenQuery",
    "operationKind": "query",
    "text": "query InstructorDetailScreenQuery(\n  $facilitySlug: String!\n  $instructorId: ID!\n) {\n  node(id: $instructorId) {\n    __typename\n    ... on StaffProfile {\n      ...InstructorHeaderFragment_staffProfile\n      id\n    }\n    id\n  }\n  session {\n    ...InstructorHeaderFragment_session\n    ...LessonsSignedOutBanner_session\n  }\n  facility(slug: $facilitySlug) {\n    ...useFacilityLessonBookingDays_facility\n    ...InstructorAvailabilityList_facility\n    id\n  }\n}\n\nfragment InstructorAvailabilityList_facility on Facility {\n  id\n  publicLessonsPermissionSet {\n    bookingWindowDays\n    patronSelectVenue\n    id\n  }\n  privateLessonsPermissionSet {\n    bookingWindowDays\n    patronSelectVenue\n    id\n  }\n  club {\n    supportsPublic\n    id\n  }\n}\n\nfragment InstructorHeaderFragment_session on Session {\n  ...InstructorLessonTypeSelect_session\n  currentClientProfile {\n    __typename\n    member {\n      __typename\n      membershipType {\n        __typename\n        id\n      }\n      ... on Customer {\n        id\n      }\n      ... on Member {\n        id\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment InstructorHeaderFragment_staffProfile on StaffProfile {\n  id\n  ...InstructorPhotoFragment_staffProfile\n  user {\n    fullName\n    id\n  }\n  instructorDepartmentProfile(facilitySlug: $facilitySlug) {\n    headline\n    id\n  }\n}\n\nfragment InstructorLessonTypeSelect_session on Session {\n  ...LessonTypeSelect_session\n  currentClientProfile {\n    __typename\n    member {\n      __typename\n      membershipType {\n        __typename\n        id\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment InstructorPhotoFragment_staffProfile on StaffProfile {\n  profileImage {\n    publicId: renderingKey\n  }\n  user {\n    fullName\n    firstName\n    lastName\n    id\n  }\n}\n\nfragment LessonTypeSelect_session on Session {\n  ...useGetLessonTypeOptions_session\n}\n\nfragment LessonsSignedOutBanner_session on Session {\n  ...useIsUserSignedIn_session\n  ...useUserBelongsToCurrentClub_session\n  ...useCurrentClubSlug_session\n}\n\nfragment useCurrentClubSlug_session on Session {\n  currentClientProfile {\n    __typename\n    member {\n      __typename\n      club {\n        slug\n        id\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment useFacilityLessonBookingDays_facility on Facility {\n  club {\n    supportsPublic\n    id\n  }\n  privateLessonsPermissionSet {\n    bookingWindowDays\n    id\n  }\n  publicLessonsPermissionSet {\n    bookingWindowDays\n    id\n  }\n}\n\nfragment useGetLessonTypeOptions_session on Session {\n  currentClientProfile {\n    __typename\n    member {\n      __typename\n      membershipType {\n        __typename\n        id\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment useIsUserSignedIn_session on Session {\n  user {\n    __typename\n    id\n  }\n}\n\nfragment useUserBelongsToCurrentClub_session on Session {\n  currentClientProfile {\n    __typename\n    member {\n      __typename\n      ... on Customer {\n        id\n      }\n      ... on Member {\n        id\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "7dc1625ed63d988f9ffd4f1f66c2a4b3";

export default node;
